import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Markdown from "markdown-to-jsx";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  item: {
    margin: theme.spacing(10.75),
    "@media screen and (max-width: 500px)": {
      margin: theme.spacing(3.75),
    },
  },
  cardSpacing: {
    padding: theme.spacing(2.75),
  },
  submit: {
    backgroundColor: "#c6385e",
    color: "#f6e4dd",
    "& a": {
      backgroundColor: "#a51943",
      borderRadius: "60px",
      padding: "6px 10px",
      "&:hover": {
        border: "2px white solid",
        textDecoration: "none",
      },
    },
  },
}));

function Attend() {
  const classes = useStyles();

  const [submit, setSubmit] = useState("");
  useEffect(() => {
    import("./submit.md")
      .then((res) => {
        fetch(res.default)
          .then((res) => res.text())
          .then((res) => setSubmit(res))
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  });
  return (
    <Grid container className={classes.root}>
      <Grid item xs className={classes.item}>
        <Card className={classNames(classes.cardSpacing, classes.submit)}>
          <Markdown>{submit}</Markdown>
        </Card>
      </Grid>
    </Grid>
  );
}

export default Attend;
